import styled from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

export const BannerWrapper = styled(FlexRow)`
    width: 100%;
    background: ${colorsPalettes.carbon[0]};
    border-radius: 6px;
    justify-content: space-between;
    align-items: end;

    box-shadow: 0px 3px 6px 0px ${rgba(colorsPalettes.carbon[500], 0.08)};
`;

export const ContentContainer = styled(FlexColumn)`
    padding: 32px 24px 32px 24px;
`;

export const BannerTitle = styled.p`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    margin: 0;
`;

export const BannerSubTitle = styled.p`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    margin: 0;
`;

export const BannerImage = styled.img`
    width: 352px;
    height: 160px;
    flex-shrink: 0;
`;

export const ButtonWrapper = styled.div`
    margin-top: 24px;
`;

export const ImageWrapper = styled.div`
    width: 100%;
    height: 100%;
    max-width: 352px;
`;
